const header = () => {
  let scrollY = window.pageYOffset || document.documentElement.scrollTop;

  document.querySelectorAll('.l-header__dropdown__item').forEach(item => {
    item.addEventListener('mouseenter', () => {
      item.classList.add('is-show');
    });
    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-show');
    });
  });

  window.addEventListener('scroll', () => {
    scrollY = window.pageYOffset || document.documentElement.scrollTop;
  });

  const toggleNav = () => {
    const headerbtn = document.querySelector('.l-header__btn');
    headerbtn.addEventListener('click', () => {
      document.documentElement.classList.toggle('is-open-h');
      document.body.classList.toggle('is-open');
    });
  };

  toggleNav();

  window.addEventListener('scroll', () => {
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY || window.pageYOffset;
    const bodyElement = document.body;

    if (scrollY > viewportHeight) {
      bodyElement.classList.add('is-scroll-vh');
    } else {
      bodyElement.classList.remove('is-scroll-vh');
    }
  });

  var entryBtn = document.getElementById('js-entry-btn');

  entryBtn.addEventListener('click', function() {
    // クリックでclassをトグル（付与＆削除）
    entryBtn.classList.toggle('is-entry');
  });

};
